export default `
  fragment UserBylineFragment on users {
    id
    username
    name
    image:cached_image
    cover:cached_cover
    flair
    booksCount: books_count
    followersCount: followers_count
    bio
  }
`;
